import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Production/Form/NewBuildingBlockInspectionStatus/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_projects,
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import {
    v3_fetchNewBuildingBlockInspectionStatusFields,
    v3_submitNewBuildingBlockInspectionStatus,

} from '../../../actions/v3/productionForm';
import { NumberFormatBase } from 'react-number-format';
import Swal from 'sweetalert2';

const NewBuildingBlockInspectionStatus = (props) => {

    const location = useLocation();
    const { data } = location.state || {};
    // 1. Rename state to items (flat list)
    const defaultRow = {
        grand_block_name: { name: 'grand_block_name', value: '', error: '', isRequired: true },
        block_no: { name: 'block_no', value: '', error: '', isRequired: true },
        hull_inspection_yard_sch: { name: 'hull_inspection_yard_sch', value: '', error: '', isRequired: false },
        hull_inspection_inspn_date: { name: 'hull_inspection_inspn_date', value: '', error: '', isRequired: false },
        surface_prep_inspn_yard_sch: { name: 'surface_prep_inspn_yard_sch', value: '', error: '', isRequired: false },
        surface_prep_inspn_inspn_date: { name: 'surface_prep_inspn_inspn_date', value: '', error: '', isRequired: false },
        paint_final_inspn_yard_sch: { name: 'paint_final_inspn_yard_sch', value: '', error: '', isRequired: false },
        paint_final_inspn_inspn_date: { name: 'paint_final_inspn_inspn_date', value: '', error: '', isRequired: false },
        machinery_and_electrical_insp_equipment: { name: 'machinery_and_electrical_insp_equipment', value: '', error: '', isRequired: false },
        machinery_and_electrical_insp_yard_sch: { name: 'machinery_and_electrical_insp_yard_sch', value: '', error: '', isRequired: false },
        machinery_and_electrical_insp_inspn_date: { name: 'machinery_and_electrical_insp_inspn_date', value: '', error: '', isRequired: false },
        outfitting_insp_item: { name: 'outfitting_insp_item', value: '', error: '', isRequired: false },
        outfitting_insp_yard_sch: { name: 'outfitting_insp_yard_sch', value: '', error: '', isRequired: false },
        outfitting_insp_inspn_date: { name: 'outfitting_insp_inspn_date', value: '', error: '', isRequired: false }
    };

    const [state, setState] = useState([defaultRow]);
    const handleChange = (field, value, index = 0) => {
        setState(prevState => {
            const updatedState = [...prevState];
            updatedState[index][field] = {
                ...updatedState[index][field],
                value,
                error: '',
            };
            return updatedState;
        });
    };

    const addRow = () => {
        setState(prev => [...prev, JSON.parse(JSON.stringify(defaultRow))]);
    };

    const removeRow = (indexToRemove) => {
        setState(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const [commonDetails, setCommonDetails] = useState({
        project: { value: '', options: [], error: '' },
        ship: { value: '', options: [], error: '' },
        date: { value: '', error: '' },
        finalSubmit: { value: false },
        block_count: { value: '' },
        yard: { value: '' },


    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });
    }, []);

    // Load ships when project changes
    useEffect(() => {
        if (commonDetails.project.value) {
            v2_ships(null, commonDetails.project.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.project.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;
        if (params) {
            setShowLoader(true);

            v3_fetchNewBuildingBlockInspectionStatusFields(
                params.PROJECT_ID,
                params.SHIP_ID
            )
                .then((res) => {
                    if (res.status) {
                        const { commonDetails, records = [] } = res.result;

                        // set common details if editing
                        if (params.PROJECT_ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                project: { ...prev.project, value: commonDetails?.PROJECT_ID || '' },
                                ship: { ...prev.ship, value: commonDetails?.SHIP_ID || '' },
                                date: { ...prev.date, value: commonDetails?.SUBMISSION_DATE || '' },
                                finalSubmit: { value: Boolean(commonDetails?.FINAL_SUBMITTED) },
                                block_count: { value: commonDetails?.TOTAL_BLOCKS || '' },

                            }));
                        }

                        // convert flat records to form model
                        const mappedItems = records.map((item) => {
                            return {
                                entryId: item.ID,
                                grand_block_name: {
                                    ...defaultRow.grand_block_name,
                                    value: item.GRAND_BLOCK_NAME || '',
                                },
                                block_no: {
                                    ...defaultRow.block_no,
                                    value: item.BLOCK_NO || '',
                                },
                                hull_inspection_yard_sch: {
                                    ...defaultRow.hull_inspection_yard_sch,
                                    value: item.HULL_INSPECTION_YARD_SCH || '',
                                },
                                hull_inspection_inspn_date: {
                                    ...defaultRow.hull_inspection_inspn_date,
                                    value: item.HULL_INSPECTION_INSPN_DATE || '',
                                },
                                surface_prep_inspn_yard_sch: {
                                    ...defaultRow.surface_prep_inspn_yard_sch,
                                    value: item.SURFACE_PREP_INSPN_YARD_SCH || '',
                                },
                                surface_prep_inspn_inspn_date: {
                                    ...defaultRow.surface_prep_inspn_inspn_date,
                                    value: item.SURFACE_PREP_INSPN_INSPN_DATE || '',
                                },
                                paint_final_inspn_yard_sch: {
                                    ...defaultRow.paint_final_inspn_yard_sch,
                                    value: item.PAINT_FINAL_INSPN_YARD_SCH || '',
                                },
                                paint_final_inspn_inspn_date: {
                                    ...defaultRow.paint_final_inspn_inspn_date,
                                    value: item.PAINT_FINAL_INSPN_INSPN_DATE || '',
                                },
                                machinery_and_electrical_insp_equipment: {
                                    ...defaultRow.machinery_and_electrical_insp_equipment,
                                    value: item.MACHINERY_AND_ELECTRICAL_INSP_EQUIPMENT || '',
                                },
                                machinery_and_electrical_insp_yard_sch: {
                                    ...defaultRow.machinery_and_electrical_insp_yard_sch,
                                    value: item.MACHINERY_AND_ELECTRICAL_INSP_YARD_SCH || '',
                                },
                                machinery_and_electrical_insp_inspn_date: {
                                    ...defaultRow.machinery_and_electrical_insp_inspn_date,
                                    value: item.MACHINERY_AND_ELECTRICAL_INSP_INSPN_DATE || '',
                                },
                                outfitting_insp_item: {
                                    ...defaultRow.outfitting_insp_item,
                                    value: item.OUTFITTING_INSP_ITEM || '',
                                },
                                outfitting_insp_yard_sch: {
                                    ...defaultRow.outfitting_insp_yard_sch,
                                    value: item.OUTFITTING_INSP_YARD_SCH || '',
                                },
                                outfitting_insp_inspn_date: {
                                    ...defaultRow.outfitting_insp_inspn_date,
                                    value: item.OUTFITTING_INSP_INSPN_DATE || '',
                                },
                            };
                        });

                        // set state (renamed from state to items if needed)
                        setState(mappedItems);
                    } else {
                        toast.error(res.error);
                    }
                })
                .catch(() => toast.error('Something went wrong while fetching.'))
                .finally(() => setShowLoader(false));
        }

    }, []);

    const onSubmit = async () => {
        // 1. Validation
        const errors = [];
        if (!commonDetails.project.value) errors.push('Select a project.');
        if (!commonDetails.ship.value) errors.push('Select a ship.');
        if (!commonDetails.block_count.value || commonDetails.block_count.value.trim() === "") {
            errors.push("Total No of Blocks is required.");
        }
        // Validate each row
        state.forEach((row, index) => {
            Object.entries(row).forEach(([key, field]) => {
                if (key === 'entryId') return; // Skip entryId

                const isRequired = field.isRequired || commonDetails.finalSubmit.value; // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`Row ${index + 1}: ${key.replace(/_/g, ' ')} is required.`);
                }
            });
        });


        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }

        const totalBlocks = parseInt(commonDetails.block_count.value, 10);
        if (isNaN(totalBlocks) || totalBlocks !== state.length) {
            toast.error(`Total No of Blocks (${totalBlocks}) must match number of rows (${state.length}).`);
            return;
        }



        // 2. Build checklistItems payload
        const checklistItems = state.map((row) => {
            const formattedRow = {};
            Object.keys(row).forEach((key) => {
                formattedRow[key.toUpperCase()] = row[key].value;
            });
            if (row['entryId']) {
                formattedRow.ID = row['entryId']
            }
            return formattedRow;
        });

        // 3. Build full payload
        const payload = {
            commonDetails: {
                project: commonDetails.project.value,
                ship: commonDetails.ship.value,
                date: commonDetails.date.value,
                finalSubmit: commonDetails.finalSubmit.value,
                block_count: commonDetails.block_count.value,
                yard: commonDetails.yard.value,
            },
            checklistItems,
        };

        // 4. Submit
        setShowLoader(true);
        v3_submitNewBuildingBlockInspectionStatus(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.submittedNewBuildingBlockInspectionStatus.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };
    useEffect(() => {
        const selected = commonDetails.ship.options.find(
            (i) => i.ID == commonDetails.ship.value
        );

        if (selected) {
            setCommonDetails((prev) => ({
                ...prev,
                yard: {
                    ...prev.yard,
                    value: selected.YARD_NAME || ''
                }
            }));
        }
    }, [commonDetails.ship.value, commonDetails.ship.options]);


    return (
        <Layout title="Block Inspection Status">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>BLOCK INSPECTION STATUS</h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery
                                                of the vessel
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 pl10">
                                                        <p>Project</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            value={commonDetails.project.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    project: { ...prev.project, value: e.target.value },
                                                                }))
                                                            }
                                                        >

                                                            <option value={''}>Select Project</option>
                                                            {commonDetails.project.options.map((item) => {
                                                                return (<option value={item.ID}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>

                                                    <td className="hd-s2 pl10">
                                                        <p>Hull</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            disabled={data ? true : false}
                                                            value={commonDetails.ship.value}
                                                            onChange={(e) => {
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    ship: { ...prev.ship, value: e.target.value }
                                                                }));
                                                            }}


                                                        >

                                                            <option value={''}>Select Hull</option>
                                                            {commonDetails.ship.options.map((item) => {
                                                                return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>

                                                    <td className="hd-s2 pl10">
                                                        <p>Yard</p>
                                                    </td>
                                                    <td className="">
                                                        <input
                                                            className="form-control"
                                                            type='text'
                                                            value={commonDetails.yard.value}
                                                            placeholder='Autofill'
                                                            disabled
                                                        />


                                                    </td>


                                                    <td className="hd-s2 pl10">
                                                        <p>Date</p>
                                                    </td>
                                                    <td className="">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={commonDetails.date.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    date: { ...prev.date, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10 w150">
                                                        <p>Total No of Blocks</p>
                                                    </td>
                                                    <td className="">
                                                        <NumberFormatBase
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="No of Blocks"
                                                            value={commonDetails.block_count.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    block_count: { ...prev.block_count, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}
                                addRow={addRow}
                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                            />


                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus